import React, {useState} from 'react';
import {
   Image,
   Text,
   View,
   StyleSheet,
   Dimensions,
   TouchableOpacity,
   Platform,
} from 'react-native';
import {
   moduleListRowBGColor,
   courseSerialNumberColor,
   FONT_FAMILY_REGULAR,
   WHITE_TEXT_HOVER_COLOR,
   WHITE_ICON_HOVER_TINT_COLOR,
} from '../../utils/utils';
import logger from '../../utils/logger';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {isChrome, isEdge, isWindows} from 'react-device-detect';

const {width, height} = Dimensions.get('window');
const rowHeight =
   Dimensions.get('window').height > Dimensions.get('window').width ? 40 : 64;
const isLandscapeMode =
   Dimensions.get('window').height > Dimensions.get('window').width
      ? false
      : true;
const textWidth = width - 16 * 2 - rowHeight - rowHeight - 10 * 2;
const serialViewHeight =
   Dimensions.get('window').height > Dimensions.get('window').width ? 24 : 40;
const serialViewLeftMargin =
   Dimensions.get('window').height > Dimensions.get('window').width ? 8 : 18;
const playIconHeight =
   Dimensions.get('window').height > Dimensions.get('window').width ? 24 : 40;
const iconSize =
   Dimensions.get('window').height > Dimensions.get('window').width ? 14.4 : 24;

const ModuleSlideItem = ({icon, title, index, isScrollable}) => {
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const styles = style(isLandscapeMode, rowHeight);
   const [isRowHover, setRowHover] = useState(false);

   return (
      <View
         onMouseEnter={() => setRowHover(true)}
         onMouseLeave={() => setRowHover(false)}
         style={{
            marginLeft:
               isWindows && (isChrome || isEdge)
                  ? null
                  : !isLandscapeMode
                  ? 16
                  : 24,
            marginRight:
               isWindows && (isChrome || isEdge) && isScrollable
                  ? 24
                  : isWindows && (isChrome || isEdge) && !isScrollable
                  ? 0
                  : !isLandscapeMode
                  ? 16
                  : 24,
         }}>
         {/** Unlocked courses and locked courses have different parent views */}

         <View style={styles.item}>
            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  ...Platform.select({
                     web: {
                        justifyContent: 'flex-start',
                        width: !isLandscapeMode ? '80%' : '85%',
                     },
                  }),
               }}>
               <View
                  style={{
                     backgroundColor: '#808080',
                     borderRadius: serialViewHeight / 2,
                     height: serialViewHeight,
                     width: Platform.OS === 'web' ? '80%' : serialViewHeight,
                     maxWidth: serialViewHeight,
                     left: serialViewLeftMargin,
                     alignContent: 'center',
                     alignItems: 'center',
                     justifyContent: 'center',
                  }}>
                  <Text
                     numberOfLines={2}
                     style={[
                        styles.serialTitle,
                        isRowHover && {color: WHITE_TEXT_HOVER_COLOR},
                     ]}>
                     {parseInt(index) + 1}
                  </Text>
               </View>

               <Text
                  style={[
                     styles.title,
                     {
                        ...Platform.select({
                           web: {
                              width: !isLandscapeMode ? '80%' : null,
                              marginLeft: !isLandscapeMode ? 24 : 34,
                           },
                        }),
                     },
                     isRowHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>{`${title}`}</Text>
            </View>

            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  ...Platform.select({
                     web: {
                        justifyContent: 'flex-end',
                        width: !isLandscapeMode ? '20%' : '15%',
                     },
                  }),
               }}>
               <View
                  style={{
                     borderRadius: playIconHeight / 2,
                     height: playIconHeight,
                     width: playIconHeight,
                     alignContent: 'center',
                     alignItems: 'center',
                     justifyContent: 'center',
                     right: !isLandscapeMode ? 8 : 12,
                     backgroundColor: '#313131',
                  }}
                  onPress={() => {
                     logger('play module');
                  }}>
                  <Image
                     style={[
                        {width: iconSize, height: iconSize},
                        isRowHover && {tintColor: WHITE_ICON_HOVER_TINT_COLOR},
                     ]}
                     source={require('../../assets/arrow-play.png')}
                  />
               </View>
            </View>
         </View>
      </View>
   );
};

const style = (isLandscapeMode, rowHeight) =>
   StyleSheet.create({
      item: {
         flexDirection: 'row',
         alignItems: 'center',
         justifyContent: 'space-between',
         marginHorizontal: 0,
         minHeight: rowHeight,
         backgroundColor: '#454545',
         borderRadius: 4,
      },
      title: {
         fontSize: !isLandscapeMode ? 14 : 20,
         fontFamily: FONT_FAMILY_REGULAR,
         marginLeft: !isLandscapeMode ? 16 : 34,
         marginRight: 10,
         color: 'white',
         fontWeight: '600',
         opacity: 1,
         width: textWidth,
      },
      serialTitle: {
         fontSize: !isLandscapeMode ? 14 : 20,
         fontWeight: '600',
         fontFamily: FONT_FAMILY_REGULAR,
         color: 'white',
         textAlign: 'center',
         maxWidth: rowHeight,
         marginBottom: 0.25,
      },
   });

export default ModuleSlideItem;
